export default 'Your entry does not match the allowed pattern.';